export default __webpack_public_path__ + "static/media/jobs-role-hero-shape-1.6e13aba1.svg";